import React from 'react';
import { Avatar } from '@mui/material';

const AvatarWrapper = (props) => {
  return(
    <Avatar>{props.first_name.charAt(0)}{props.last_name?.charAt(0)}</Avatar>
  );
}

export default AvatarWrapper;